export default __webpack_public_path__ + "static/media/aakash-byjus-logo.20bed8ef.svg";